import { getCountryCodeFromHostname } from "./country";

const productionApiBaseUrls = {
  cz: "https://servisy-api.myayvens.cz",
  sk: "https://servisy-api.myayvens.sk",
};

const testApiBaseUrls = {
  cz: "https://cz-servisy-api-test.automotive.ald.socgen",
  sk: "https://sk-servisy-api-test.automotive.ald.socgen",
};

export const getApiBaseUrlFromHostname = (
  hostname: string,
  fallbackApiBaseUrl: string = productionApiBaseUrls.cz
) => {
  const normalizedHostname = hostname.trim().toLowerCase().replace(/\.$/, "");
  const countryCode = getCountryCodeFromHostname(normalizedHostname);

  if (normalizedHostname.endsWith(".automotive.ald.socgen")) {
    return countryCode === "sk" ? testApiBaseUrls.sk : testApiBaseUrls.cz;
  }

  const topLevelDomain = normalizedHostname.split(".").pop();
  if (topLevelDomain === "sk" || topLevelDomain === "cz") {
    return countryCode === "sk"
      ? productionApiBaseUrls.sk
      : productionApiBaseUrls.cz;
  }

  return fallbackApiBaseUrl;
};
